import dedent from 'ts-dedent'
import { Provider, WorkflowComponentCodeParams, WorkflowComponentParamType } from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class Unnest extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.unnest',
        group: 'Aggregation',
        title: 'Unnest',
        description: `
        This component unnests the arrays contained in a column.
    `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'col',
          type: WorkflowComponentParamType.Column,
          title: 'Column',
          parent: 'source'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return `
    SELECT * EXCEPT (${params.col})
    FROM ${connection.quoteName(params.source as string)}, UNNEST (${params.col}) ${params.col}_unnested`
      case Provider.DatabricksRest:
        return dedent`
    SELECT /*+ REPARTITION(40) */
      * EXCEPT (${params.col}), EXPLODE (${params.col}) AS ${params.col}_unnested
    FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getVersion(provider: Provider): string {
    return '3'
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.DatabricksRest]
  }
}

export { Unnest }
